import { ComponentGroup } from '../types.js'

const donut = new URL('../../../icons/components/donut.png', import.meta.url).href
const ellipse = new URL('../../../icons/components/ellipse.png', import.meta.url).href
const polygon = new URL('../../../icons/components/polygon.png', import.meta.url).href
const rect = new URL('../../../icons/components/rect.png', import.meta.url).href
const star = new URL('../../../icons/components/star.png', import.meta.url).href
const triangle = new URL('../../../icons/components/triangle.png', import.meta.url).href

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:none;stroke:{{strokeColor}};stroke-width:2;stroke-miterlimit:10;}
  </style>
  <g>
    <polyline class="st0" points="21.6,9.4 21.6,4.6 1.6,4.6 1.6,17.7 12.5,17.7 	"/>
    <circle class="st0" cx="21.3" cy="18.3" r="7"/>
  </g>
</svg>
`

export const shape: ComponentGroup = {
  name: 'shape',
  description: 'a group of simple basic shapes',
  icon,
  templates: [
    {
      type: 'rect',
      description: 'rectangle shape',
      icon: rect,
      group: 'shape',
      model: {
        type: 'rect',
        left: 100,
        top: 100,
        width: 100,
        height: 100,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'ellipse',
      description: 'ellipse shape',
      icon: ellipse,
      group: 'shape',
      model: {
        type: 'ellipse',
        rx: 50,
        ry: 50,
        cx: 150,
        cy: 150,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'triangle',
      description: 'triangle shape',
      icon: triangle,
      group: 'shape',
      model: {
        type: 'triangle',
        x1: 150,
        y1: 100,
        x2: 100,
        y2: 200,
        x3: 200,
        y3: 200,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    }
  ]
}
